import { FormattedText, LandingButton, ParaTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import { useEffect, useState } from "react";
import { formatDate } from "../../utils";
import {
  BottomBarIcon,
  BottomBarSection,
  CalenderFooterWrap,
  CalenderFootRange,
  CalFootRangeCol,
} from "./CalendarFooter.style";

interface CalenderFooterType {
  checkinDate?: Date;
  checkoutDate?: Date;
  onSubmitButtonPress?: (chkIn?: Date, chkOut?: Date) => void;
  bottomBarDescription?: any;
  bottomBarIcon?: string;
}

const CalendarFooter = ({
  checkinDate,
  checkoutDate,
  onSubmitButtonPress,
  bottomBarDescription,
  bottomBarIcon,
}: CalenderFooterType) => {
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);

  return (
    <CalenderFooterWrap>
      {bottomBarDescription && (
        <BottomBarSection>
          {bottomBarIcon && (
            <BottomBarIcon src={bottomBarIcon} alt="bottomBarIcon" />
          )}
          <FormattedText
            value={bottomBarDescription}
            baseStyle={{
              fontSize: "14px",
              fontWeight: "700",
              color: theme.blackText,
            }}
          />
        </BottomBarSection>
      )}
      <CalenderFootRange>
        <CalFootRangeCol selected={selected === 0}>
          <ParaTag
            textTransform="uppercase"
            fontSize="xs"
            fontWeight="bold"
            color={selected === 0 ? `var(--tm-accent-color)` : theme.greyText7}
          >
            start date
          </ParaTag>
          <ParaTag fontWeight="bold">
            {checkinDate ? formatDate(checkinDate) : "-"}
          </ParaTag>
        </CalFootRangeCol>
        <CalFootRangeCol selected={selected === 1}>
          <ParaTag
            textTransform="uppercase"
            fontSize="xs"
            fontWeight="bold"
            color={selected === 1 ? `var(--tm-accent-color)` : theme.greyText7}
          >
            end date
          </ParaTag>
          <ParaTag fontWeight="bold">
            {checkoutDate ? formatDate(checkoutDate) : "-"}
          </ParaTag>
        </CalFootRangeCol>
      </CalenderFootRange>
      <LandingButton
        customWidth="100%"
        onClick={
          onSubmitButtonPress
            ? () => onSubmitButtonPress(checkinDate, checkoutDate)
            : () => {}
        }
        customTitle="Confirm"
        disableState={!checkinDate || !checkoutDate}
      />
    </CalenderFooterWrap>
  );
};

export default CalendarFooter;
